import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { APP_NAME } from "constants/app.constant";
import { useSelector } from "react-redux";

const LOGO_SRC_PATH = "/img/logo/";

const Logo = (props) => {
  const { type, mode, gutter, className, imgClass, style, logoWidth } = props;
  const { userData } = useSelector((state) => state?.auth?.user);
  return (
    <div
      className={classNames("logo", className, gutter)}
      style={{
        ...style,
        ...{ width: logoWidth },
      }}
      // className="px-6 py-8  bg-sky-900 "
    >
      <img
        className={`${imgClass} min-w-full h-14 min-h-full`}
        src={`${
          userData.gym_logo
            ? userData.gym_logo
            : `${LOGO_SRC_PATH}logo-${mode}-${type}.svg`
        }`}
        alt={`${APP_NAME} logo`}
      />
    </div>
  );
};

Logo.defaultProps = {
  mode: "light",
  type: "full",
  logoWidth: "auto",
};

Logo.propTypes = {
  mode: PropTypes.oneOf(["light", "dark"]),
  type: PropTypes.oneOf(["full", "streamline"]),
  gutter: PropTypes.string,
  imgClass: PropTypes.string,
  logoWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Logo;
